import React, { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom'; // ✅ Import navigation

const WhiteList = () => {
    const [number, setNumber] = useState('');
    const [numbers, setNumbers] = useState([]);
    const navigate = useNavigate(); // ✅ Initialize navigation

    const handleAdd = () => {
        if (number.trim() !== '') {
            setNumbers([...numbers, number]);
            setNumber('');
        }
    };

    const handleDelete = (index) => {
        const updated = numbers.filter((_, i) => i !== index);
        setNumbers(updated);
    };

    const handleClose = () => {
        navigate('/users'); // ✅ Redirect to /users
    };

    const handleDownload = () => {
        const content = numbers.join('\n');
        const blob = new Blob([content], { type: 'text/plain' });
        const link = document.createElement('a');
        link.download = 'whitelist.txt';
        link.href = URL.createObjectURL(blob);
        link.click();
    };

    return (
        <Box
            sx={{
                width: 400,
                mx: 'auto',
                mt: 4,
                p: 3,
                borderRadius: 2,
                boxShadow: 1,
                backgroundColor: '#fff',
                position: 'relative',
            }}
        >
            {/* Close Button */}
            <IconButton
                onClick={handleClose}
                sx={{ position: 'absolute', top: 8, right: 8, color: 'gray' }}
            >
                <CloseIcon />
            </IconButton>

            <Typography
                variant="subtitle1"
                sx={{ fontWeight: 'bold', mb: 2, color: '#1a237e' }}
            >
                White List
            </Typography>

            <Box sx={{ display: 'flex', mb: 2 }}>
                <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Enter Number Here"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                />
                <Button
                    variant="contained"
                    sx={{
                        ml: 1,
                        background: 'linear-gradient(to right, #0052D4, #4364F7)',
                        color: '#fff',
                        textTransform: 'none',
                        fontWeight: 500,
                        borderRadius: 1,
                        px: 2,
                    }}
                    onClick={handleAdd}
                >
                    Add
                </Button>
            </Box>

            <List>
                {numbers.map((num, index) => (
                    <ListItem key={index} divider>
                        <ListItemText primary={`${index + 1}. ${num}`} />
                        <ListItemSecondaryAction>
                            <IconButton
                                edge="end"
                                onClick={() => handleDelete(index)}
                                sx={{
                                    backgroundColor: 'red',
                                    color: '#fff',
                                    '&:hover': { backgroundColor: '#c62828' },
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                    variant="contained"
                    onClick={handleDownload}
                    sx={{
                        background: 'linear-gradient(to right, #0052D4, #4364F7)',
                        textTransform: 'none',
                        fontWeight: 500,
                        borderRadius: 1,
                    }}
                >
                    Download ↓
                </Button>
            </Box>
        </Box>
    );
};

export default WhiteList;
